import Checkbox, { CheckboxProps } from "@material-ui/core/Checkbox";
import { FieldInputProps } from "formik";
import * as React from "react";

type Props = CheckboxProps & {
    field?: FieldInputProps<boolean>;
    isTouched?: boolean;
    label?: string;
};

export const CustomCheckbox = ({ style, label, field, checked, onChange, indeterminate, ...props }: Props) => {
    const isChecked = field?.checked ?? checked ?? false;

    return (
        <div style={{ marginLeft: "none", display: "flex" }}>
            <Checkbox
                value={field?.value}
                name={field?.name}
                checked={isChecked}
                onChange={(event: React.ChangeEvent<any>, checked: boolean) => {
                    if (field) {
                        field.onChange(event);
                    }
                    if (onChange) {
                        onChange(event, checked);
                    }
                }}
                onBlur={field?.onBlur}
                aria-label={props["aria-label"]}
                style={style}
                disableRipple
                indeterminate={indeterminate}
            />
            {label}
        </div>
    );
};
